<template>
  <div class="inbound-manage">
    <page-header title="入库管理" icon="el-icon-download" />
    <!-- 搜索区域 -->
    <div class="search-box">
      <el-card shadow="never">
        <el-form :inline="true" :model="queryParams" class="search-form" size="small">
          <el-form-item label="入库单号">
            <el-input v-model="queryParams.orderNo" placeholder="请输入入库单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="入库类型">
            <el-select v-model="queryParams.type" placeholder="请选择入库类型" clearable>
              <el-option label="采购入库" value="1"></el-option>
              <el-option label="退货入库" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库时间">
            <el-date-picker
              v-model="queryParams.timeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="search-btn-group">
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-toolbar">
      <el-button-group>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增入库</el-button>
        <el-button type="success" icon="el-icon-download" size="small">导出</el-button>
      </el-button-group>
    </div>

    <!-- 数据表格 -->
    <div class="table-box">
      <el-table
        :data="inboundList"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{
          background:'#f5f7fa',
          color:'#606266',
          fontWeight: '600',
          padding: '12px 0',
          height: '50px'
        }"
        :cell-style="{
          padding: '8px 0',
          height: '50px'
        }"
        height="calc(100vh - 280px)">
        <el-table-column type="index" label="序号" width="60" align="center"/>
        <el-table-column prop="orderNo" label="入库单号" width="180" align="center" show-overflow-tooltip/>
        <el-table-column prop="type" label="入库类型" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === '1' ? 'primary' : 'warning'" size="small" effect="plain">
              {{ scope.row.type === '1' ? '采购入库' : '退货入库' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="productCount" label="商品数量" width="100" align="right">
          <template slot-scope="scope">
            <span class="count">{{ scope.row.productCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="总金额" width="150" align="right">
          <template slot-scope="scope">
            <span class="price">¥ {{ scope.row.totalAmount.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'info'" size="small" effect="plain">
              {{ scope.row.status === '1' ? '已完成' : '待入库' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" align="center"/>
        <el-table-column prop="remark" label="备注" min-width="200" align="left" show-overflow-tooltip/>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button-group class="operation-group">
              <el-button size="mini" type="primary" icon="el-icon-view" @click="handleDetail(scope.row)">详情</el-button>
              
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog 
      :title="dialog.title" 
      :visible.sync="dialog.visible" 
      width="900px" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="custom-dialog">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="入库类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择入库类型" style="width: 200px">
            <el-option label="采购入库" value="1"></el-option>
            <el-option label="退货入库" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品信息">
          <div class="table-operator">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAddProduct">添加商品</el-button>
          </div>
          <el-table 
            :data="form.products" 
            border 
            :header-cell-style="{
              background:'#f5f7fa',
              color:'#606266',
              fontWeight: '600',
              padding: '8px 0',
              height: '45px'
            }"
            :cell-style="{
              padding: '4px 0',
              height: '45px'
            }"
            class="inner-table">
            <el-table-column label="商品名称" min-width="200" align="left">
              <template slot-scope="scope">
                <el-select v-model="scope.row.productId" placeholder="请选择商品" style="width: 90%">
                  <el-option
                    v-for="item in productOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="库存" width="120" align="right">
              <template slot-scope="scope">
                <span>{{ getProductStock(scope.row.productId) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="入库数量" width="150" align="right">
              <template slot-scope="scope">
                <el-input-number 
                  v-model="scope.row.quantity" 
                  :min="1"
                  controls-position="right"
                  style="width: 120px">
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleRemoveProduct(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark" :rows="3" placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/common/PageHeader'

export default {
  name: 'InboundManage',
  components: {
    PageHeader
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderNo: '',
        type: '',
        timeRange: []
      },
      // 日期选择器快捷选项
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 表格数据
      inboundList: [],
      // 商品选项
      productOptions: [],
      loading: false,
      total: 0,
      // 对话框
      dialog: {
        visible: false,
        title: ''
      },
      // 表单数据
      form: {
        type: '1',
        products: [],
        remark: ''
      },
      // 表单校验规则
      rules: {
        type: [
          { required: true, message: '请选择入库类型', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getList()
    this.getProductOptions()
  },
  methods: {
    // 获取商品选项
    getProductOptions() {
      this.productOptions = [
        { value: 1, label: 'iPhone 15 Pro Max', stock: 100, price: 9999.00 },
        { value: 2, label: 'MacBook Pro M3', stock: 50, price: 15999.00 },
        { value: 3, label: 'iPad Pro', stock: 80, price: 6999.00 },
        { value: 4, label: 'AirPods Pro', stock: 200, price: 1999.00 },
        { value: 5, label: 'Apple Watch Series 9', stock: 150, price: 3999.00 }
      ]
    },
    // 获取入库单列表
    getList() {
      this.loading = true
      setTimeout(() => {
        this.inboundList = [
          {
            id: 1,
            orderNo: 'IN202403010001',
            type: '1',
            productCount: 100,
            totalAmount: 999999.00,
            status: '1',
            createTime: '2024-03-01 10:00:00',
            remark: '采购入库-电子产品',
            products: [
              { productId: 1, quantity: 50, price: 9999.00 },
              { productId: 2, quantity: 30, price: 15999.00 },
              { productId: 3, quantity: 20, price: 6999.00 }
            ]
          },
          {
            id: 2,
            orderNo: 'IN202403010002',
            type: '2',
            productCount: 50,
            totalAmount: 59999.00,
            status: '0',
            createTime: '2024-03-01 11:00:00',
            remark: '退货入库',
            products: [
              { productId: 4, quantity: 30, price: 1999.00 },
              { productId: 5, quantity: 20, price: 3999.00 }
            ]
          }
        ]
        this.total = 100
        this.loading = false
      }, 500)
    },
    // 查询按钮
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    // 重置按钮
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        orderNo: '',
        type: '',
        timeRange: []
      }
      this.getList()
    },
    // 新增按钮
    handleAdd() {
      this.dialog.title = '新增入库单'
      this.dialog.visible = true
      this.form = {
        type: '1',
        products: [],
        remark: ''
      }
    },
    // 添加商品
    handleAddProduct() {
      this.form.products.push({
        productId: '',
        quantity: 1
      })
    },
    // 移除商品
    handleRemoveProduct(index) {
      this.form.products.splice(index, 1)
    },
    // 详情按钮
    handleDetail(row) {
      // 查看详情逻辑
    },
    // 删除按钮
    handleDelete(row) {
      this.$confirm('确认删除该入库单吗？', '提示', {
        type: 'warning'
      }).then(() => {
        // 调用删除接口
        this.$message.success('删除成功')
        this.getList()
      })
    },
    // 提交表单
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.products.length === 0) {
            this.$message.warning('请添加入库商品')
            return
          }
          // 调用保存接口
          this.$message.success('保存成功')
          this.dialog.visible = false
          this.getList()
        }
      })
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.getList()
    },
    // 页码改变
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/common.css';

.count {
  font-family: Arial, sans-serif;
  font-weight: 500;
  color: #409eff;
}

.price {
  font-family: Arial, sans-serif;
  font-weight: 500;
  color: #f56c6c;
}

:deep(.el-table) {
  th.el-table__cell {
    background-color: #f5f7fa !important;
    
    .cell {
      font-weight: 600;
      color: #606266;
    }
  }
  
  td.el-table__cell {
    .cell {
      line-height: 23px;
    }
  }
  
  tbody tr:hover > td {
    background-color: #f5f7fa !important;
  }
}

.operation-group {
  .el-button {
    padding: 6px 12px;
    
    &:not(:last-child) {
      border-right: 1px solid #dcdfe6;
    }
    
    &:hover {
      position: relative;
      z-index: 1;
    }
  }
}

:deep(.el-tag) {
  &.el-tag--primary {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
  }
  
  &.el-tag--warning {
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }
  
  &.el-tag--success {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  
  &.el-tag--info {
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;
  }
}

.custom-dialog {
  .el-form-item {
    margin-bottom: 24px;
  }
  
  .inner-table {
    margin: 12px 0;
    
    .el-select {
      margin-left: 8px;
    }
  }
}

.table-operator {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 0 8px;
}

// 调整表格内容垂直对齐
:deep(.el-table__cell) {
  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    
    &.is-right {
      justify-content: flex-end;
      padding-right: 16px;
    }
    
    &.is-left {
      justify-content: flex-start;
      padding-left: 16px;
    }
  }
}

// 调整表格内按钮组的间距
:deep(.el-button+.el-button) {
  margin-left: 0;
}

// 调整表格内的tag样式
:deep(.el-tag) {
  margin: 0 4px;
}


.dealer-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .filter-container {
    padding-bottom: 10px;
  }

  .operation-container {
    margin-bottom: 20px;
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .upload-demo {
    margin-bottom: 20px;
  }

  .el-upload__tip {
    line-height: 1.2;
    margin-top: 5px;
    color: #909399;
  }
}
</style> 